module.exports = __webpack_public_path__ + "media/globe_loop_light.aef4dafd.mp4";